import helpers from 'helpers'

const mountTransfer = (data, entityId) => {
  const quantity = data.kind === 'quantity'

  return {
    entityId: entityId,
    entityType: 'Seller',
    ...data,
    rangeFrom: quantity
      ? data.rangeFrom
      : helpers.formatters.currencyOutput(data.rangeFrom),
    rangeTo: quantity
      ? data.rangeTo
      : helpers.formatters.currencyOutput(data.rangeTo),
  }
}

export default mountTransfer
